import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import EditOutlined from '@ant-design/icons/EditOutlined';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import HistoryOutlined from '@ant-design/icons/HistoryOutlined';
import ReloadOutlined from '@ant-design/icons/ReloadOutlined';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ onClose, handleLogout }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigate = (path) => {
    navigate(path);
    onClose?.();
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton onClick={() => handleNavigate('/profile/edit')}>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary={t('profile.menu.editProfile')} />
      </ListItemButton>
      <ListItemButton onClick={() => handleNavigate('/profile/view')}>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary={t('profile.menu.viewProfile')} />
      </ListItemButton>
      <ListItemButton onClick={() => handleNavigate('/billing/history')}>
        <ListItemIcon>
          <HistoryOutlined />
        </ListItemIcon>
        <ListItemText primary={t('profile.menu.billingHistory')} />
      </ListItemButton>
      <ListItemButton onClick={() => handleNavigate('/upgrade')}>
        <ListItemIcon>
          <ReloadOutlined />
        </ListItemIcon>
        <ListItemText primary={t('profile.menu.renewSubscription')} />
      </ListItemButton>
      <ListItemButton onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary={t('profile.menu.logout')} />
      </ListItemButton>
    </List>
  );
}

ProfileTab.propTypes = {
  onClose: PropTypes.func,
  handleLogout: PropTypes.func
};
